export const yearsPronunciation = (years: number) => {
  if (years === 1) {
    return 'rok'
  }
  if (years > 1 && years < 5) {
    return 'lata'
  }
  return 'lat'
}
